import { Label } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { isFromBuilderSelector } from 'shared/selectors';

export function FromDeveloperLabel() {
  const isFromBuilder = useSelector(isFromBuilderSelector);

  if (!isFromBuilder) {
    return null;
  }

  return (
    <Label color="text-primary-default" background="accent-ghost-secondary">
      От застройщика
    </Label>
  );
}
